import React from 'react'
import ActionPolling from 'atoms/ActionPolling'
import { refetchLiveChats } from 'actions/liveChats'

export default () => (
  <ActionPolling
    delay={15000}
    action={refetchLiveChats}
  />
)
